import React from 'react';
import PropTypes from 'prop-types';

import useLogInPlaidLink from '../../../../hooks/useLoginPlaidLink';
import FlatButton from '../../../FlatButton';
import InlineAlert from '../../../InlineAlert';
import { Paragraph } from '../../../Typography';

import styles from './LogInBankAlert.module.scss';

const LogInBankAlert = ({ paymentMethodId }) => {
  const { open, loading } = useLogInPlaidLink({ paymentMethodId });

  return (
    <InlineAlert type="warning" contentClassName={styles.content}>
      <div className={styles.textHolder}>
        <Paragraph weight="bold" className="mb-8">
          Plaid connection expired
        </Paragraph>
        <Paragraph className="mt-0 mb-0">
          To use this payment method, you’ll need to log in with Plaid.
        </Paragraph>
      </div>
      <FlatButton
        disabled={loading}
        loading={loading}
        className={styles.button}
        onClick={open}
      >
        log in
      </FlatButton>
    </InlineAlert>
  );
};

LogInBankAlert.propTypes = {
  paymentMethodId: PropTypes.string,
};

export default LogInBankAlert;
